export default __webpack_public_path__ + "static/media/icon-lesSoignants.a216c3f6.svg";